<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";
import BreadCrumbDynamic from "@/components/BreadCrumbDynamic.vue";
import router from "@/router";

export default defineComponent({
  name: "MinistriesList",
  components: {BreadCrumbDynamic},
  computed: {
    moment() {
      return moment
    },
    brItems() {
      return this.$store.state.brItems
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      parent_id: null,
      page: 1,
      totalCount: 0,
      limit: 10,
    }
  },
  methods: {
    onClickBrItem(id, index) {
      this.parent_id = id;
      this.$store.commit('sliceBrItems', index);
      this.getMinistries()
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getMinistries();
    },
    handleSizeChange() {
      this.page = 1;
      this.getMinistries();
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/ministries/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getMinistries();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    onClickRow(row) {
      this.parent_id = row['id'];
      this.$store.commit('updateBrItems', {
        id: row['id'],
        title: row['title']
      })
      this.getMinistries()
    },
    getMinistries() {
      this.loading = true;
      this.$http.get(`api/v1/ministries`, {
        params: {
          parent_id: this.brItems[this.brItems.length - 1]?.id,
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    this.$store.commit('clearBrItems')
    this.$store.commit('updateBrItems', {
      title: 'Vazirliklar',
      id: null
    })
    this.getMinistries()
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div>
        <bread-crumb-dynamic :items="brItems" @onClickItem="onClickBrItem"/>
      </div>
      <el-button type="primary" @click="$router.push({name: 'MinistryFormAdd',query:{parent: parent_id}})">Qo'shish
      </el-button>
    </div>
    <el-table :data="tableData"
              class="table"
              border
              row-style="cursor:pointer"
              @rowClick="onClickRow"
              height="calc(100vh - 245px)">
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column prop="title" label="Nomi" min-width="220"/>
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="120">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="230" align="center">
        <template #default="scope">
          <el-button type="success" size="small"
                     @click.stop="$router.push({name: 'MinistryFormAdd', query:{parent: scope.row.id}})">+
          </el-button>
          <el-button type="primary" size="small"
                     @click.stop="$router.push({name: 'MinistryFormEdit', params:{id: scope.row.id}})">Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click.stop="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
